export const FETCH_WIP_CODES_REQUEST = 'FETCH_WIP_CODES_REQUEST';
export const FETCH_WIP_CODES_SUCCESS = 'FETCH_WIP_CODES_SUCCESS';
export const FETCH_WIP_CODES_FAILURE = 'FETCH_WIP_CODES_FAILURE';

export const FETCH_WIP_CODE_REQUEST = 'FETCH_WIP_CODE_REQUEST';
export const FETCH_WIP_CODE_SUCCESS = 'FETCH_WIP_CODE_SUCCESS';
export const FETCH_WIP_CODE_FAILURE = 'FETCH_WIP_CODE_FAILURE';

export const ADD_WIP_CODE_REQUEST = 'ADD_WIP_CODE_REQUEST';
export const ADD_WIP_CODE_SUCCESS = 'ADD_WIP_CODE_SUCCESS';
export const ADD_WIP_CODE_FAILURE = 'ADD_WIP_CODE_FAILURE';

export const UPDATE_WIP_CODE_REQUEST = 'UPDATE_WIP_CODE_REQUEST';
export const UPDATE_WIP_CODE_SUCCESS = 'UPDATE_WIP_CODE_SUCCESS';
export const UPDATE_WIP_CODE_FAILURE = 'UPDATE_WIP_CODE_FAILURE';

export const DELETE_WIP_CODE_REQUEST = 'DELETE_WIP_CODE_REQUEST';
export const DELETE_WIP_CODE_SUCCESS = 'DELETE_WIP_CODE_SUCCESS';
export const DELETE_WIP_CODE_FAILURE = 'DELETE_WIP_CODE_FAILURE';

export const FETCH_WIP_CODES_SCOPE_REQUEST = 'FETCH_WIP_CODES_SCOPE_REQUEST';
export const FETCH_WIP_CODES_SCOPE_SUCCESS = 'FETCH_WIP_CODES_SCOPE_SUCCESS';
export const FETCH_WIP_CODES_SCOPE_FAILURE = 'FETCH_WIP_CODES_SCOPE_FAILURE';

export const FETCH_WIP_CODES_ORDER_REQUEST = 'FETCH_WIP_CODES_ORDER_REQUEST';
export const FETCH_WIP_CODES_ORDER_SUCCESS = 'FETCH_WIP_CODES_ORDER_SUCCESS';
export const FETCH_WIP_CODES_ORDER_FAILURE = 'FETCH_WIP_CODES_ORDER_FAILURE';

export const SAVE_WIP_CODES_ORDER_REQUEST = 'SAVE_WIP_CODES_ORDER_REQUEST';
export const SAVE_WIP_CODES_ORDER_SUCCESS = 'SAVE_WIP_CODES_ORDER_SUCCESS';
export const SAVE_WIP_CODES_ORDER_FAILURE = 'SAVE_WIP_CODES_ORDER_FAILURE';
